module.exports = __webpack_public_path__ + "static/img/about-banner.7f0d4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-banner.png
// module id = KI8p
// module chunks = 1